// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Bootstrap Imports
import InputGroup from 'react-bootstrap/InputGroup'

export default function BilledCurrencyText({ size = 'sm' }) {
   const state = useQuoteContext()
   const { getString } = state

   let buttonStyle
   if (state.user_role == 'Partner' || state.user_role == 'Reseller')
      buttonStyle = { width: 200, margin: 10 }
   else buttonStyle = {}

   return (
      <InputGroup
         style={buttonStyle}
         className='justify-content-center'
         size={size}
      >
         <InputGroup.Text size={size}>
            {getString('product.BilledCurrencyText.Text')}
         </InputGroup.Text>
         <InputGroup.Text size={size}>
            {state.previousCurrencyCode}
         </InputGroup.Text>
      </InputGroup>
   )
}
